module.exports = __webpack_public_path__ + "static/mamat-d13eedf66823d42c695d25b89a379d35.jpg";